import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Expand } from '@sparefoot/react-core';

import { Paragraph, H3 } from 'components/core/Typography';
import { Image } from 'components/core/Image';
import { Button } from 'components/core/Button';
import { Link } from 'components/core/Link';

import expandIcon from 'assets/images/icons/expand.svg';
import collapseIcon from 'assets/images/icons/collapse.svg';

import './accordion.scss';
import MarkdownWrapper from 'components/atoms/MarkdownWrapper/MarkdownWrapper';

export function AccordionItem({ title, copy, className, link, preserve }) {
	const [copyExpanded, setCopyExpanded] = useState(false);
	const handleExpandCopy = () => setCopyExpanded((prev) => !prev);
	return (
		<div
			className={classnames(className, 'accordion-item', {
				expanded: copyExpanded,
			})}
		>
			<Button
				onClick={handleExpandCopy}
				className="expand-button"
			>
				<H3
					weight="bold"
					className="item-title"
				>
					<MarkdownWrapper
						inline
						content={[{ type: 'faq_content', value: title }]}
					/>
				</H3>
				<Image
					src={copyExpanded ? collapseIcon : expandIcon}
					className="expand-button-image"
				/>
			</Button>
			<Expand
				showing={copyExpanded}
				preserve={preserve}
			>
				<div>
					<Paragraph
						weight="light"
						last
					>
						<MarkdownWrapper
							inline
							content={[{ type: 'faq_content', value: copy }]}
						/>
					</Paragraph>
					{link && (
						<H3
							weight="bold"
							last
							className="copy-link"
						>
							<Link href={link}>More info on {title}</Link>
						</H3>
					)}
				</div>
			</Expand>
		</div>
	);
}

AccordionItem.propTypes = {
	title: PropTypes.string.isRequired,
	copy: PropTypes.string.isRequired,
	className: PropTypes.string,
	link: PropTypes.string,
	preserve: PropTypes.bool,
};

export default AccordionItem;
